function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useContext, useEffect } from 'react';
import { useState } from 'react';
import { Input } from 'antd';
import { CreditCardOutlined } from 'iglooicon';
import { Visa, MasterCard } from 'iglooicon';
import omit from 'omit.js';
import classnames from 'classnames';
import formMethods from "../utils/form-methods";
import { LocaleContext, staticFormatMessage } from "../locale";
import "./style/index";
import { jsx as _jsx } from "react/jsx-runtime";
var defaultCheck = [{
  name: 'Visa',
  reg: '^4[0-9]{12}(?:[0-9]{3})?$',
  icon: /*#__PURE__*/_jsx(Visa, {
    style: {
      fontSize: 24
    }
  })
}, {
  name: 'MasterCard',
  reg: '^5[1-5][0-9]{14}$',
  icon: /*#__PURE__*/_jsx(MasterCard, {
    style: {
      fontSize: 24
    }
  })
}];
var defaultCardIcon = /*#__PURE__*/_jsx(CreditCardOutlined, {
  style: {
    color: '#eeeeee',
    fontSize: 24
  }
});
function getErrorMessage(cardRules) {
  var finalConfig = cardRules.pop();
  var maxIndex = cardRules.length - 1;
  var typeNames = cardRules.reduce(function (res, current, index) {
    var name = current.name;
    if (index < maxIndex) {
      return res += name + ',';
    }
    return res += name;
  }, '');
  var _ref = finalConfig,
    finalName = _ref.name;
  return {
    typeNames: typeNames,
    finalName: finalName
  };
}
var IglooCredit = function IglooCredit(props) {
  var className = props.className,
    _props$suffix = props.suffix,
    suffix = _props$suffix === void 0 ? defaultCardIcon : _props$suffix,
    _props$cardConfig = props.cardConfig,
    cardConfig = _props$cardConfig === void 0 ? [] : _props$cardConfig,
    formChangeProps = props.onChange,
    setFieldError = props.setFieldError,
    value = props.value;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    formValue = _useState2[0],
    setFormValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    inputSeparate = _useState4[0],
    setSeparateValue = _useState4[1];
  var _useState5 = useState(suffix),
    _useState6 = _slicedToArray(_useState5, 2),
    cardIcon = _useState6[0],
    setCardIcon = _useState6[1];

  // 为了在 国际化指令中 存在这一条语种配置
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  var staticMessage = formatMessage({
    id: 'Credit card must be {typeNames} or {finalName}'
  });
  function separatePureNum(pureInput) {
    var res = '';
    var index = 0;
    while (pureInput.substr(index * 4, 4) !== '') {
      var thisPart = pureInput.substr(index * 4, 4);
      res += thisPart + "".concat(thisPart.length === 4 ? ' ' : '');
      index++;
    }
    var lastStr = res.substr(res.length - 1, 1);
    return lastStr === ' ' ? res.substring(0, res.length - 1) : res;
  }
  function judgeCardType(inputValue, cardRules) {
    for (var i = 0; i < cardRules.length; i++) {
      var _cardRules$i = cardRules[i],
        reg = _cardRules$i.reg,
        icon = _cardRules$i.icon;
      var regObj = new RegExp(reg);
      if (regObj.test(inputValue)) {
        formChangeProps && formChangeProps(inputValue);
        setCardIcon(icon);
        return;
      }
    }
    setCardIcon(defaultCardIcon);
  }
  function handleOnChange(value, cardRules, formOnChange) {
    var pureNumInput = value.replace(/[^0-9]/gi, '');
    if (pureNumInput.length === formValue.length && value[value.length - 1] === '') {
      // 删除了空格,得删除一个数字
      pureNumInput = pureNumInput.substring(0, pureNumInput.length - 1);
    }
    setFormValue(pureNumInput);
    judgeCardType(pureNumInput, cardRules);
    setSeparateValue(separatePureNum(pureNumInput));

    // 空值校验
    if (!pureNumInput) {
      formOnChange && formOnChange(pureNumInput);
      return;
    }
    for (var i = 0; i < cardRules.length; i++) {
      var reg = cardRules[i].reg;
      var regObj = new RegExp(reg);
      if (regObj.test(pureNumInput)) {
        formOnChange && formOnChange(pureNumInput);
        return;
      }
    }
    formOnChange && formOnChange('error type');
    setFieldError && setFieldError(formatMessage({
      id: 'Credit card must be {typeNames} or {finalName}',
      values: getErrorMessage(cardRules)
    }));
  }
  useEffect(function () {
    if (value && value !== 'error type') {
      handleOnChange(value, [].concat(_toConsumableArray(cardConfig), defaultCheck), formChangeProps);
    }
  }, [value]);
  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({}, omit(props, [].concat(_toConsumableArray(formMethods), ['cardConfig']))), {}, {
    suffix: cardIcon,
    className: classnames(className, 'igloo-input'),
    value: inputSeparate,
    onChange: function onChange(e) {
      return handleOnChange(e.target.value, [].concat(_toConsumableArray(cardConfig), defaultCheck), formChangeProps);
    }
  }));
};
function checkCard(value, cardRules) {
  if (!value) {
    return Promise.resolve();
  }
  for (var i = 0; i < cardRules.length; i++) {
    var reg = cardRules[i].reg;
    var regObj = new RegExp(reg);
    if (regObj.test(value)) {
      return Promise.resolve();
    }
  }
  return Promise.reject(staticFormatMessage({
    id: 'Credit card must be {typeNames} or {finalName}',
    values: getErrorMessage(cardRules)
  }));
}
IglooCredit.formItemPropsHandler = function (config) {
  var _config$cardConfig = config.cardConfig,
    cardConfig = _config$cardConfig === void 0 ? [] : _config$cardConfig;
  return {
    rules: [{
      validator: function validator(_, value) {
        return checkCard(value, [].concat(_toConsumableArray(cardConfig), defaultCheck));
      }
    }]
  };
};
export default IglooCredit;